import React from 'react';
import PropTypes from 'prop-types';

import './flexboxgrid.scss';

const gutterSize = gutter => {
  if (gutter === 'no-gut') return gutter;
  return `gut-${gutter}`;
};

const Row = ({ children, gutter, justifyContent, alignItems }) => {
  return (
    <div
      className={[
        'row',
        gutter && gutterSize(gutter),
        justifyContent && `justify-content-${justifyContent}`,
        alignItems && `align-items-${alignItems}`,
      ]
        .filter(className => className)
        .join(' ')}
    >
      {children}
    </div>
  );
};

Row.propTypes = {
  children: PropTypes.node.isRequired,
  gutter: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', 'no-gut']),
  justifyContent: PropTypes.oneOf([
    'start',
    'space-between',
    'space-around',
    'space-evenly',
    'center',
    'end',
  ]),
  alignItems: PropTypes.oneOf(['start', 'center', 'end', 'stretch']),
};

Row.defaultProps = {
  gutter: 'no-gut',
  justifyContent: null,
  alignItems: null,
};

export default Row;
